import React, { useState, useEffect } from 'react';
import CardItem from './CardItem';
import { CONFIG } from '../utils/config';
import { Row, Col, Button } from 'react-bootstrap';

const ListItems = props => {
  const { viewStyle, allPosts, nextLink, fetchLoadMoreMethod, postcodeSearch, moreToDisplay, errorMessage } = props;

  const [categoryTerms, setCategoryTerms] = useState([]);
  const [ageTerms, setAgeTerms] = useState([]);

  const fetchTaxonomyTerms = async (id, setMethod) => {
    const url = `${CONFIG.API_URL}/api/taxonomy_term/${id}`;
    const response = await fetch(url);
    const fetchedTerms = await response.json();

    if (fetchedTerms?.data) {
      setMethod(fetchedTerms.data)
    }
  }

  useEffect(() => {
    fetchTaxonomyTerms('industry', setCategoryTerms);
    fetchTaxonomyTerms('age_range', setAgeTerms);
  }, [])

  return (
    <>
      <Row>
        {allPosts.map(item => (
          <CardItem
            viewStyle={viewStyle}
            data={item}
            key={item.attributes['drupal_internal__nid']}
            postcodeSearch={postcodeSearch}
            categoryTerms={categoryTerms}
            ageTerms={ageTerms}
          />
        ))}
      </Row>
      <Row>
        {nextLink || (postcodeSearch && moreToDisplay) ? (
          <Col className="mx-auto">
            <Button
              className="mx-auto loadmorebtn fw-800 mx-auto"
              onClick={fetchLoadMoreMethod}
            >
              Load More
            </Button>
          </Col>
        ) : (
          <Col>
            <p className="text-center fw-800">{errorMessage}</p>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ListItems;
